// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ic3sWqEFZFtdN_qCDcAb {
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
	max-height: 400px;
	overflow-y: auto;
	padding: 0.4rem;
}

.Li5PsVu8eN8cuG5ilszQ {
	display: flex;
	flex-direction: column;
	gap: 0.35rem;
	align-self: flex-start;
	max-width: min(80%, 520px);
	width: fit-content;
}

.Ku0BSLgiFsv8Cg91wl8F {
	align-items: flex-start;
}

._uZjpWOv_Zffu_9gGCQ2 {
	align-items: flex-end;
	align-self: flex-end;
	text-align: right;
}

.LxE8i9XupEMdlzBVDCfk {
	background-color: #f3f4f6;
	border-radius: 1rem;
	box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
	color: #1f2937;
	padding: 0.75rem 1rem;
	display: flex;
	flex-direction: column;
	gap: 0.35rem;
	word-break: break-word;
    font-weight: 600 !important;
}

._uZjpWOv_Zffu_9gGCQ2 .LxE8i9XupEMdlzBVDCfk {
	background-color: #f26c3a;
	color: #ffffff !important;
}

.uL3JHD9AByAdpoj2xz2D {
	align-self: flex-end;
	font-size: 1.2rem;
    color: #6b7280;
}

.o0DbbjDxqY0YeiIRAlfZ {
	display: flex;
	align-items: center;
	gap: 0.35rem;
	color: #6b7280;
	font-size: 1.2rem;
}

._uZjpWOv_Zffu_9gGCQ2 .o0DbbjDxqY0YeiIRAlfZ {
	justify-content: flex-end;
	color: rgba(255, 255, 255, 0.75);
}

.wZW9IrGepwNJpN3DqH93 {
	white-space: nowrap;
}

.E1xiMeCAJI4flZFVMJ4h {
	line-height: 1;
}

._uZjpWOv_Zffu_9gGCQ2 .E1xiMeCAJI4flZFVMJ4h {
	color: rgba(255, 255, 255, 0.75);
}

.kzAz1Hzz8GZAYPADKboc {
	opacity: 0.7;
	font-style: italic;
}

.GE1Y6Fh6lXME352gZjFW {
	width: 100%;
}
`, "",{"version":3,"sources":["webpack://./pages/CRM/components/Details/style.module.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,sBAAsB;CACtB,WAAW;CACX,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,YAAY;CACZ,sBAAsB;CACtB,0BAA0B;CAC1B,kBAAkB;AACnB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,qBAAqB;CACrB,oBAAoB;CACpB,iBAAiB;AAClB;;AAEA;CACC,yBAAyB;CACzB,mBAAmB;CACnB,4CAA4C;CAC5C,cAAc;CACd,qBAAqB;CACrB,aAAa;CACb,sBAAsB;CACtB,YAAY;CACZ,sBAAsB;IACnB,2BAA2B;AAC/B;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;AAC1B;;AAEA;CACC,oBAAoB;CACpB,iBAAiB;IACd,cAAc;AAClB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,YAAY;CACZ,cAAc;CACd,iBAAiB;AAClB;;AAEA;CACC,yBAAyB;CACzB,gCAAgC;AACjC;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,WAAW;AACZ","sourcesContent":[".container {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 1.5rem;\n\tmax-height: 400px;\n\toverflow-y: auto;\n\tpadding: 0.4rem;\n}\n\n.messageRow {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 0.35rem;\n\talign-self: flex-start;\n\tmax-width: min(80%, 520px);\n\twidth: fit-content;\n}\n\n.prospect {\n\talign-items: flex-start;\n}\n\n.agent {\n\talign-items: flex-end;\n\talign-self: flex-end;\n\ttext-align: right;\n}\n\n.bubble {\n\tbackground-color: #f3f4f6;\n\tborder-radius: 1rem;\n\tbox-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);\n\tcolor: #1f2937;\n\tpadding: 0.75rem 1rem;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 0.35rem;\n\tword-break: break-word;\n    font-weight: 600 !important;\n}\n\n.agent .bubble {\n\tbackground-color: #f26c3a;\n\tcolor: #ffffff !important;\n}\n\n.agentTimestamp {\n\talign-self: flex-end;\n\tfont-size: 1.2rem;\n    color: #6b7280;\n}\n\n.meta {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 0.35rem;\n\tcolor: #6b7280;\n\tfont-size: 1.2rem;\n}\n\n.agent .meta {\n\tjustify-content: flex-end;\n\tcolor: rgba(255, 255, 255, 0.75);\n}\n\n.metaText {\n\twhite-space: nowrap;\n}\n\n.dot {\n\tline-height: 1;\n}\n\n.agent .dot {\n\tcolor: rgba(255, 255, 255, 0.75);\n}\n\n.emptyMessage {\n\topacity: 0.7;\n\tfont-style: italic;\n}\n\n.datePicker {\n\twidth: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export var container = `Ic3sWqEFZFtdN_qCDcAb`;
export var messageRow = `Li5PsVu8eN8cuG5ilszQ`;
export var prospect = `Ku0BSLgiFsv8Cg91wl8F`;
export var agent = `_uZjpWOv_Zffu_9gGCQ2`;
export var bubble = `LxE8i9XupEMdlzBVDCfk`;
export var agentTimestamp = `uL3JHD9AByAdpoj2xz2D`;
export var meta = `o0DbbjDxqY0YeiIRAlfZ`;
export var metaText = `wZW9IrGepwNJpN3DqH93`;
export var dot = `E1xiMeCAJI4flZFVMJ4h`;
export var emptyMessage = `kzAz1Hzz8GZAYPADKboc`;
export var datePicker = `GE1Y6Fh6lXME352gZjFW`;
export default ___CSS_LOADER_EXPORT___;
